import cx from 'classnames';
import React, { ReactNode } from 'react';

type CloseButtonProps = {
  label?: string;
  onClick?: () => void;
};

const CloseButton: React.FC<CloseButtonProps> = ({ label = 'Close', onClick }) => {
  return (
    <button type="button" className="close" onClick={onClick}>
      <span aria-hidden="true">&times;</span>
      <span className="sr-only">{label}</span>
    </button>
  );
};

export { CloseButton };

type ModalHeaderProps = React.PropsWithChildren<{
  closeLabel?: string;
  closeButton?: boolean;
  onHide?: () => void;
  className?: string;
  children?: ReactNode;
  bsClass?: string;
}>;

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  closeLabel = 'Close',
  closeButton = false,
  onHide,
  className,
  children,
  bsClass = 'modal-header',
  ...otherProps
}) => {
  return (
    <div {...otherProps} className={cx(bsClass, className)}>
      {closeButton && (
        <CloseButton
          label={closeLabel}
          onClick={onHide}
        />
      )}

      {children}
    </div>
  );
};